import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        // If there's a hash, let the browser handle the scroll (or manual scrollIntoView)
        // Only scroll to top if there is NO hash
        if (!hash) {
            window.scrollTo(0, 0);
        } else {
            // Optional: Ensure hash scroll happens after render
            setTimeout(() => {
                const element = document.getElementById(hash.replace('#', ''));
                if (element) {
                    element.scrollIntoView({ behavior: 'smooth' });
                }
            }, 100);
        }
    }, [pathname, hash]);

    return null;
}
